// packages/ui/src/components/AlertBox.tsx
import { Alert, Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
interface AlertBoxProps {
  type?: 'info' | 'warning' | 'error' | 'success';
  children?: React.ReactNode;
  lines?: string[];
  icon?: React.ReactNode;
  action?: React.ReactNode;
  sx?: SxProps<Theme>;
  mb?: number | string;
  /**
   * The box's ARIA role. MUI's default, `alert`, makes a screen reader announce the box as urgent;
   * a box that is part of a page's static content (a documentation tip or warning) is a `note`.
   */
  role?: 'alert' | 'note' | 'status';
}
export function AlertBox({ type = 'info', children, lines, icon, action, sx, mb = 2, role }: AlertBoxProps) {
  return (
    <Alert
      severity={type}
      icon={icon}
      action={action}
      role={role}
      sx={{
        mb,
        alignItems: 'center',
        '& .MuiAlert-icon': {
          mt: '0 !important',
        },
        '& .MuiAlert-action': {
          mt: 0,
          pt: 0,
          pb: 0,
          display: 'flex',
          alignItems: 'center',
        },
        ...sx,
      }}
    >
      {lines ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {lines.map((line, i) => <span key={i}>{line}</span>)}
        </Box>
      ) : children}
    </Alert>
  );
}
